import { useRef } from "react";
import { Carousel, Slide } from "../../../ui/Carousel/Carousel";
import { GoArrowLeft, GoArrowRight } from "react-icons/go";
import { useEffect, useState } from "react";

import "./comments.scss";

const noFile = require("../../../assets/no-file.png");

const Comments = () => {
  const carouselRef = useRef();
  const [slideCount, setSlideCount] = useState(2);
  const handleNext = () => {
    carouselRef.current?.next?.();
  };

  const handlePrev = () => {
    carouselRef.current?.prev?.();
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setSlideCount(1);
      } else {
        setSlideCount(2);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const data = [
    {
      name: "Амраа",
      text: "Хичээл үнэхээр гоё байгаа шүү🤝 дахин2 үзээл олон зүйл сурч байгаа 🔥📈 Багшдаа маш их баярлалаа",
      time: "just now",
    },
    {
      name: "Болдсайхан",
      text: "Би их гоё зүйлийн үзүүрээс атгацан байгаа тавихгүй дээ ккк Анх ямар ч мэдлэггүй Ахисан шатны хичээл үзсээн... багшийг бурхан мэт шүт гэж үнэн үг шүү Очироо багшдаа баярлалаа 🥰",
      time: "just now",
    },
    {
      name: "Оргил",
      text: "OT янзын гайхалтай онол шүү, Олон зүйлсийг ойлгуулсан маш их баярлалаа",
      time: "just now",
    },
    {
      name: "Энхтуяа",
      text: "Маш үр дүнтэй арга барил, Анх сураад мэдлэггүй байдлаасаа болоод зөндөө алдсан. Одоо тогтмол ашигтай явж байгаа.",
      time: "just now",
    },
    {
      name: "Чинзориг",
      text: "Тэр цагийн шинжилгээ бүүр аймар, зөвхөн цагаар арилжаад ашигтай явж байгаа, маш их баярлалаа",
      time: "just now",
    },
  ];
  const getAvatar = (name) =>
    `https://ui-avatars.com/api/?name=${name}&background=random&color=fff&size=128`;
  return (
    <section className="homeComments">
      <div className="homeComments__inner">
        <h3 className="homeComments__title">Сэтгэгдэл</h3>

        <div className="homeComments__carouselWrap">
          <button
            className="homeComments__nav homeComments__nav--left"
            onClick={handlePrev}
          >
            <GoArrowLeft />
          </button>

          <button
            className="homeComments__nav homeComments__nav--right"
            onClick={handleNext}
          >
            <GoArrowRight />
          </button>

          <Carousel
            ref={carouselRef}
            slideCount={slideCount}
            spaceBetween={24}
            autoplay
            autoplaySpeed={6000}
            infinite
            hiddenArrows
          >
            {data.map((item, index) => (
              <Slide key={index}>
                <div className="commentSlide">
                  <div className="commentCard">
                    <div className="commentCard__avatar">
                      <img
                        src={item.img || getAvatar(item.name)}
                        alt={item.name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noFile;
                        }}
                      />
                    </div>

                    <div className="commentCard__body">
                      <h4 className="commentCard__name">{item.name}</h4>

                      <div className="commentCard__rating">⭐⭐⭐⭐⭐</div>

                      <p className="commentCard__text">{item.text}</p>

                      <div className="commentCard__footer">
                        {/* <div className="commentCard__actions">
                          <span>Like</span>
                          <span>Dislike</span>
                          <span>Reply</span>
                        </div> */}

                        <span className="commentCard__time">{item.time}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Comments;
